/**
 * @generated SignedSource<<d0531b2caf01608fc61a7dae4bfe3093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftExhibitionsGrid_viewer$data = {
  readonly cmsNftExhibitionPages: ReadonlyArray<{
    readonly modules: {
      readonly heroBanner: ReadonlyArray<{
        readonly bannerConfig: {
          readonly startDate?: string | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"HeroBannerItem_heroBannerItemExhibition">;
      } | null> | null;
    } | null;
    readonly pageId: string | null;
    readonly pageName: string | null;
  } | null> | null;
  readonly " $fragmentType": "NftExhibitionsGrid_viewer";
};
export type NftExhibitionsGrid_viewer$key = {
  readonly " $data"?: NftExhibitionsGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionsGrid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftExhibitionsGrid_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExhibitionPagesObject",
      "kind": "LinkedField",
      "name": "cmsNftExhibitionPages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionPage",
          "kind": "LinkedField",
          "name": "modules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftCmsExhibitionHeroBannerType",
              "kind": "LinkedField",
              "name": "heroBanner",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "bannerConfig",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "startDate",
                          "storageKey": null
                        }
                      ],
                      "type": "NftCmsExhibitionHtmlBannerType",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HeroBannerItem_heroBannerItemExhibition"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2a670a5b3f4758b433ccb0936fd7c9ff";

export default node;
